// extracted by mini-css-extract-plugin
module.exports = {"submenuActive":"styles_submenuActive__Yhitw"};